interface NewSkuBadgeProps {
  className?: string
}

export function NewSkuBadge({ className }: NewSkuBadgeProps) {
  return (
    <span
      className={`inline-flex items-center px-1.5 py-0.5 text-xs font-medium rounded bg-[#FEF2F3] text-[#CF1F2E] ${className ?? ''}`}
    >
      New
    </span>
  )
}
